import { Service, inject } from '@angular/core';
import { forkJoin, map, type Observable, of } from 'rxjs';

import { type UploadedDocument } from '../models/uploaded-document';
import { type BusinessOwner } from '../models/company/business-owner';
import { isFile } from '../utils/assert-file-uploaded';

import { DocumentsUploadService } from './documents-upload.service';

/** Company documents service. */
@Service()
export class CompanyDocumentsService {
	private readonly documentsUploadService = inject(DocumentsUploadService);

	/**
	 * Prepare documents, before sending files to backend we need to upload all files into the storage.
	 * @param documents Documents.
	 */
	public prepareDocuments(documents: BusinessOwner['documents']): Observable<UploadedDocument[]> {
		return forkJoin(documents.map(document => this.prepareDocument(document)));
	}

	private prepareDocument(document: BusinessOwner['documents'][number]): Observable<UploadedDocument> {
		return isFile(document) ? this.upload(document) : of(document);
	}

	private upload(document: File): Observable<UploadedDocument> {
		return this.documentsUploadService.upload(document).pipe(
			map(uri => ({ fileUri: uri, name: document.name })),
		);
	}
}
